import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getPaginatedPurchaseOrders = async ({
  page = 1,
  pageSize = 25,
  search = '',
  statusId,
  supplierId,
  startDate,
  endDate,
}) => {
  const response = await axiosInstance.get(`${API_URL}/purchase-orders`, {
    params: {
      page,
      pageSize,
      search,
      statusId,
      supplierId,
      startDate,
      endDate,
    },
    paramsSerializer: params => {
      const query = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach(v => query.append(key, v));
        } else if (value !== undefined && value !== null && value !== '') {
          query.append(key, value);
        }
      }
      return query.toString();
    },
  });
  return response.data;
};

export const getPurchaseOrderById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/purchase-orders/${id}`);
  return response.data;
};

export const createPurchaseOrder = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/purchase-orders`, data);
  return response.data;
};

export const updatePurchaseOrder = async (id, data) => {
  const response = await axiosInstance.put(`${API_URL}/purchase-orders/${id}`, data);
  return response.data;
};

export const deletePurchaseOrder = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/purchase-orders/${id}`);
  return response.data;
};

export const autoCreatePurchaseOrder = async (workOrderId) => {
  const response = await axiosInstance.post(
    `${API_URL}/purchase-orders/auto-create`,
    { workOrderId },
  );
  return response.data;
};
